<template>
  <div>
    <el-row :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>File Manager</p>
          <el-tooltip content="Insert" placement="top">
            <el-button
              type="success"
              circle
              icon="el-icon-check"
              @click.prevent="insert()"
            ></el-button>
          </el-tooltip>
        </div>
        <el-row>
          <el-col :span="4">
            <Table />
          </el-col>
          <el-col :span="20">
            <File />
          </el-col>
        </el-row>
      </el-card>
    </el-row>
    <Dialog />
  </div>
</template>

<script>
import Table from '../components/file-manager/Table'
import File from '../components/file-manager/Image'
import Dialog from '../components/file-manager/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    File,
    Dialog
  },

  computed: {
    ...mapState('fileManager', ['loading'])
  },

  methods: {
    ...mapMutations('fileManager', ['setDialog']),
    insert() {
      this.setDialog(true)
    }
  }
}
</script>
